import { computed, reactive } from 'vue'
import { camelizeKeys } from 'humps'
import { useLoader } from './useLoader'
import { useError } from './useError'
import { useCurrentUser } from '@/services/useCurrentUser'
import { useDenominationSelect } from '@/services/useDenominationSelect'
import axios from '@/axios'

const topState = reactive({
  downloadTop: [],
})

export const useDownloads = () => {
  const { toggleShowLoader } = useLoader()
  const { toggleShowError } = useError()
  const { currentUser } = useCurrentUser()
  const { selectedDenomination } = useDenominationSelect()
  const getDownloadTop = async () => {
    try {
      toggleShowLoader(true)
      let res = await axios.get('/download')
      res = camelizeKeys(res)
      topState.downloadTop = res.data.result

      topState.downloadTop.sort((a, b) => {
        if (a.year < b.year) return 1
        if (a.year > b.year) return -1
        return 0
      })

      toggleShowLoader(false)
    } catch (e) {
      toggleShowError(true)
      toggleShowLoader(false)
    }
  }

  const downloadPdf = (type, year, denominationId) => {
    axios
      .get(`/download/${type}`, {
        params: {
          year: year,
          denominationId: denominationId,
        },
        responseType: 'blob',
      })
      .then(response => {
        const content_type = response.headers['content-type']
        const blob = new Blob([response.data], { type: content_type })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')

        //ファイル名をレスポンスヘッダから取得したい
        let filename = 'download.zip'
        const disposition = response.headers['content-disposition'].toString()
        //ファイル名
        if (disposition != null) {
          let findex = disposition.indexOf('filename*=')
          if (findex != -1) {
            filename = disposition.substring(findex + 10)
            try {
              filename = decodeURI(
                filename.substring(filename.indexOf("''") + 2),
              )
            } catch (e) {
              filename = 'downloads.zip'
            }
          } else {
            findex = disposition.indexOf('filename=')
            if (findex != -1) {
              filename = disposition.substring(findex + 9)
            }
          }
        }

        link.download = filename
        link.href = url
        link.click()
      })
      .catch(error => {
        console.log(error)
        toggleShowError(true, 'download')
      })
  }

  const downloadExcel = (year, month) => {
    axios
      .get(`/download/recetpts/attachment_form/`, {
        params: {
          // user: currentUser.id,
          year: year,
          month: month,
          denomination_id:
            currentUser.role.rank === 10 && selectedDenomination.value !== 0
              ? selectedDenomination.value.denominationId
              : null,
        },
        responseType: 'blob',
      })
      .then(response => {
        const content_type = response.headers['content-type']
        const blob = new Blob([response.data], { type: content_type })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')

        //ファイル名をレスポンスヘッダから取得したい
        let filename = 'download.zip'
        const disposition = response.headers['content-disposition'].toString()
        //ファイル名
        if (disposition != null) {
          let findex = disposition.indexOf('filename*=')
          if (findex != -1) {
            filename = disposition.substring(findex + 10)
            try {
              filename = decodeURI(
                filename.substring(filename.indexOf("''") + 2),
              )
            } catch (e) {
              filename = 'downloads.zip'
            }
          } else {
            findex = disposition.indexOf('filename=')
            if (findex != -1) {
              filename = disposition.substring(findex + 9)
            }
          }
        }

        link.download = filename
        link.href = url
        link.click()
      })
      .catch(error => {
        console.log(error)
        toggleShowError(true, 'download')
      })
  }

  const requireIdDownload = (type, year, denominationId) => {
    axios
      .get(`/download/${type}`, {
        params: {
          denominationId: denominationId,
          period: year,
        },
        responseType: 'blob',
      })
      .then(response => {
        const content_type = response.headers['content-type']
        const blob = new Blob([response.data], { type: content_type })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')

        //ファイル名をレスポンスヘッダから取得したい
        let filename = 'download.zip'
        const disposition = response.headers['content-disposition'].toString()
        //ファイル名
        if (disposition != null) {
          let findex = disposition.indexOf('filename*=')
          if (findex != -1) {
            filename = disposition.substring(findex + 10)
            try {
              filename = decodeURI(
                filename.substring(filename.indexOf("''") + 2),
              )
            } catch (e) {
              filename = 'downloads.zip'
            }
          } else {
            findex = disposition.indexOf('filename=')
            if (findex != -1) {
              filename = disposition.substring(findex + 9)
            }
          }
        }

        link.download = filename
        link.href = url
        link.click()
      })
  }

  const incomeStatementDownload = (year, denominationId) => {
    axios
      .get(`/download/incomeStatement`, {
        params: {
          year: year,
          denominationId: denominationId,
        },
        responseType: 'blob',
      })
      .then(response => {
        const content_type = response.headers['content-type']
        const blob = new Blob([response.data], { type: content_type })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')

        //ファイル名をレスポンスヘッダから取得したい
        let filename = 'download.zip'
        const disposition = response.headers['content-disposition'].toString()
        //ファイル名
        if (disposition != null) {
          let findex = disposition.indexOf('filename*=')
          if (findex != -1) {
            filename = disposition.substring(findex + 10)
            try {
              filename = decodeURI(
                filename.substring(filename.indexOf("''") + 2),
              )
            } catch (e) {
              filename = 'downloads.zip'
            }
          } else {
            findex = disposition.indexOf('filename=')
            if (findex != -1) {
              filename = disposition.substring(findex + 9)
            }
          }
        }
        link.download = filename
        link.href = url
        link.click()
      })
  }

  const downloadActions = (year, denominationId) => {
    axios
      .get(`/download/actions`, {
        params: {
          year: year,
          denominationId: denominationId,
        },
        responseType: 'blob',
      })
      .then(response => {
        const content_type = response.headers['content-type']
        const blob = new Blob([response.data], { type: content_type })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')

        //ファイル名をレスポンスヘッダから取得したい
        let filename = 'download.zip'
        const disposition = response.headers['content-disposition'].toString()
        //ファイル名
        if (disposition != null) {
          let findex = disposition.indexOf('filename*=')
          if (findex != -1) {
            filename = disposition.substring(findex + 10)
            try {
              filename = decodeURI(
                filename.substring(filename.indexOf("''") + 2),
              )
            } catch (e) {
              filename = 'downloads.zip'
            }
          } else {
            findex = disposition.indexOf('filename=')
            if (findex != -1) {
              filename = disposition.substring(findex + 9)
            }
          }
        }
        link.download = filename
        link.href = url
        link.click()
      })
  }

  const depositWithdrawalDetailsDownload = (year, denominationId) => {
    axios
      .get(`/download/depositWithdrawalDetails`, {
        params: {
          year: year,
          denominationId: denominationId,
        },
        responseType: 'blob',
      })
      .then(response => {
        const content_type = response.headers['content-type']
        const blob = new Blob([response.data], { type: content_type })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')

        //ファイル名をレスポンスヘッダから取得したい
        let filename = 'download.zip'
        const disposition = response.headers['content-disposition'].toString()
        //ファイル名
        if (disposition != null) {
          let findex = disposition.indexOf('filename*=')
          if (findex != -1) {
            filename = disposition.substring(findex + 10)
            try {
              filename = decodeURI(
                filename.substring(filename.indexOf("''") + 2),
              )
            } catch (e) {
              filename = 'downloads.zip'
            }
          } else {
            findex = disposition.indexOf('filename=')
            if (findex != -1) {
              filename = disposition.substring(findex + 9)
            }
          }
        }

        link.download = filename
        link.href = url
        link.click()
      })
  }

  return {
    downloadTop: computed(() => topState.downloadTop),
    getDownloadTop,
    downloadPdf,
    downloadExcel,
    requireIdDownload,
    incomeStatementDownload,
    downloadActions,
    depositWithdrawalDetailsDownload,
  }
}
